import { useQuery } from '@tanstack/react-query';
import { PERMISSION_CATALOG, type Grant, type PermissionGroup } from '@cathouse/contracts';
import { http, qk } from '@/shared/api';
import { StatusChip } from '@/shared/ui';

export const SCOPE_LABEL = { own: 'Của mình', team: 'Nhóm', all: 'Toàn sàn' } as const;
export const SCOPE_TONE = { own: '', team: 'info', all: 'brand' } as const;

export const usePermissionCatalog = () =>
  useQuery({ queryKey: qk.permissions.catalog(), queryFn: () => http.get<PermissionGroup[]>('/permissions/catalog'), initialData: PERMISSION_CATALOG, staleTime: Infinity });

export function ScopeTag({ value }: { value: Grant | undefined }) {
  if (!value || value === true) return null;
  return <StatusChip tone={SCOPE_TONE[value]}>{SCOPE_LABEL[value]}</StatusChip>;
}

export interface MyPermissions {
  staffId?: string;
  pv: number;
  status: string | null;
  groups: { module: string; label: string; items: { key: string; label: string; scope?: 'own' | 'team' | 'all' }[] }[];
}
